/**
 * provenanceExportStore -- user preferences for export provenance tagging.
 *
 * Controls what kind of provenance tag is applied when exporting/downloading
 * plots from the Thread UI. Persisted to localStorage.
 */

import { create } from "zustand";
import type { TagMode } from "../components/provenance/ProvenanceTag";

const STORAGE_KEY = "thread-export-tag-mode";

interface ProvenanceExportState {
  tagMode: TagMode;
  setTagMode: (mode: TagMode) => void;
}

export const useProvenanceExportStore = create<ProvenanceExportState>((set) => ({
  tagMode: (() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (stored === "qr" || stored === "aruco" || stored === "both" || stored === "none") {
        return stored;
      }
    } catch { /* noop */ }
    return "qr" as const;
  })(),
  setTagMode: (mode) => {
    set({ tagMode: mode });
    try {
      localStorage.setItem(STORAGE_KEY, mode);
    } catch { /* noop */ }
  },
}));
